// src/api/api.js
import axios from "axios";
import { createBrowserHistory } from "history";
export const history = createBrowserHistory();
//const baseUrl = "http://localhost:3700/api";
//const baseUrl = "https://middleware.paynet.pk/api";
//const baseUrl = "http://localhost:3000/api";
//const baseUrl = "https://middleware.paynet.pk/api";

// const baseUrl = "http://203.175.74.252/api";

// const baseUrl = "http://203.175.74.144:3700/api/";

const baseUrl = "https://uatsoftpos.mindscraft.pk/api";
//const baseUrl = "http://localhost:3000/api";

//const baseUrl = "http://203.175.74.144:40000/api";

const api = axios.create({
  baseURL: baseUrl,
  headers: { "Content-Type": "application/json" },
});

// Automatically add token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      localStorage.removeItem("token"); // clear invalid token
      history.push("/"); // redirect to login
      window.location.reload(); // force reload so React Router applies redirect
    }
    return Promise.reject(error);
  }
);

export const loginApi = async (username, password) => {
  const response = await api.post("/login", {
    username,
    password,
clientType: "WEB", 
  });
  return response.data;
};

export const getMerchantTerminalStats = async () => {
  const response = await api.get("portal/merchant-terminal-stat");
  return response.data;
};
export const getAllMerchants = async () => {
  const response = await api.get("portal/all-merchants");
  return response.data;
};

export const reportingStats = async (tid, mid) => {
  const response = await api.post("portal/reportingStats", {
    TID: tid,
    MID: mid,
  });
  return response.data;
};
export const getTransactionMessages = async (mongoID) => {
  console.log('mongoid',mongoID)
  const response =await api.get(`portal/transaction/messages/${mongoID}`);
  
 return response.data;
};
// ── Dashboard Analytics (NEW) ─────────────────────────────────────────────────
 
/** Merchant active/inactive counts */
export const getMerchantStats = async () => {
  const response = await api.get("portal/analytics/merchant-stats");
  return response.data;
};
 
/** Monthly transaction counts (last 3 months) — bar chart */
export const getMonthlyTransactionChart = async () => {
  const response = await api.get("portal/analytics/monthly-transactions");
  return response.data;
};
 
/** Monthly volume + avg deal size — area/line chart */
export const getTransactionVolumeChart = async () => {
  const response = await api.get("portal/analytics/transaction-volume");
  return response.data;
};
 
/** Merchants with ≤15 transactions + risk level */
export const getUnderperformingMerchants = async () => {
  const response = await api.get("portal/analytics/underperforming-merchants");
  return response.data;
};
 
/** Quick insight metrics (success rate, avg value, peak hour, etc.) */
export const getDashboardInsights = async () => {
  const response = await api.get("portal/analytics/dashboard-insights");
  return response.data;
};
 
/** Top 5 merchants by transaction count */
export const getTopPerformers = async () => {
  const response = await api.get("portal/analytics/top-performers");
  return response.data;
};
 
/** Merchant tier distribution — donut chart */
export const getMerchantTierDistribution = async () => {
  const response = await api.get("portal/analytics/merchant-tier-distribution");
  return response.data;
};
export const disputedTransactions = async (tid, mid) => {
  const response = await api.post("portal/disputedTransactions", {
    TID: tid,
    MID: mid,
  });
  return response.data;
};
export const voidedTransactions = async (tid, mid) => {
  const response = await api.post("portal/voidedTransactions", {
    TID: tid,
    MID: mid,
  });
  return response.data;
};
export const declinedTransactions = async (tid, mid) => {
  const response = await api.post("portal/declinedTransactions", {
    TID: tid,
    MID: mid,
  });
  return response.data;
};
export const settledTransactions = async (tid, mid) => {
  const response = await api.post("portal/settledTransactions", {
    TID: tid,
    MID: mid,
  });
  return response.data;
};

export const totalTransactions = async (tid, mid) => {
  const response = await api.post("portal/totalTransactions", {
    TID: tid,
    MID: mid,
  });
  return response.data;
};
export const getTerminalWiseReport = async () => {
  const response = await api.get("portal/report/terminal-wise");
  return response.data;
};

export const getMerchantWiseReport = async () => {
  const response = await api.get("portal/report/merchant-wise");
  return response.data;
};

export const getCityWiseReport = async () => {
  const response = await api.get("portal/report/city-wise");
  return response.data;
};

export const getProvinceWiseReport = async () => {
  const response = await api.get("portal/report/province-wise");
  return response.data;
};

export const getMccWiseReport = async () => {
  const response = await api.get("portal/report/mcc-wise");
  return response.data;
};
export const getDailyVolumeReportApi = async (startDate, endDate) => {
  const response = await fetch(`${baseUrl}/portal/daily-volume-report`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ startDate, endDate }),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.message || "Failed to generate report");
  }

  // Returns a blob for file download
  const blob = await response.blob();
  return blob;
};
export const unsettledTransactions = async (tid, mid) => {
  const response = await api.post("portal/unsettledTransactions", {
    TID: tid,
    MID: mid,
  });
  return response.data;
};
export const todayTransactions = async (tid, mid) => {
  const response = await api.post("portal/todayTransactions", {
    TID: tid,
    MID: mid,
  });
  return response.data;
};
export const unbindDevice = async (mid, tid) => {
  console.log("{ MID: mid,TID: tid }", { MID: mid, TID: tid });
  const response = await api.post("unbindDevice", { MID: mid, TID: tid });
  return response.data;
};

export const updateSerialNumber = async (mid, tid, serialNumber) => {
  const response = await api.post("update-serial-number", {
    MID: mid,
    TID: tid,
    serialNumber,
  });
  return response.data;
};
export const getReportingStats = async () => {
  const response = await api.get("portal/reportingStats");
  return response.data;
};

export const getDisputedTransactions = async () => {
  const response = await api.get("portal/disputedTransactions");
  return response.data;
};
export const getDeclinedTransactions = async () => {
  const response = await api.get("portal/declinedTransactions");
  return response.data;
};
export const getSettledTransactions = async () => {
  const response = await api.get("portal/settledTransactions");
  return response.data;
};

export const getTotalTransactions = async () => {
  const response = await api.get("portal/totalTransactions");
  return response.data;
};
export const getMerchantBatchReport = async (mid, tid) => {
  const response = await api.get(`/portal/merchant-batch-report/${mid}/${tid}`);
  return response.data;
};

export const getUnsettledTransactions = async () => {
  const response = await api.get("portal/unsettledTransactions");
  return response.data;
};
export const getVoidedTransactions = async () => {
  const response = await api.get("portal/voidedTransactions");
  return response.data;
};
export const getTodayTransactions = async () => {
  const response = await api.get("portal/todayTransactions");
  return response.data;
};
export const registerUser = async (body) => {
  const response = await api.post("register", {
    username: body.username,
    password: body.password,
    name: body.name,
    user_type: body.user_type,
    roles: body.roles,
  });
  return response.data;
};
export const resetTerminalPassword = async (body) => {
  const response = await api.post("reset-password", {
    PhoneNumber: body.phone,
    TID: body.tid,
  });
  return response.data;
};

export const fetchAllUsers = async () => {
  const response = await api.get("users");
  return response.data;
};
export const updateUserByID = async (id, body) => {
  const response = await api.put(`users/${id}`, {
    name: body.name,
    user_type: body.user_type,
    roles: body.roles,
  });
  return response.data;
};
export const deleteUserByID = async (id) => {
  const response = await api.delete(`users/${id}`);
  return response.data;
};

export const fetchInventory = async () => {
  const response = await api.get("portal/inventory");
  return response.data;
};

export const uploadInventory = async (items, mode) => {
  const response = await api.post("portal/inventory/upload", {
    items,
    mode,
  });
  return response.data;
};

export const updateInventoryItem = async (id, body) => {
  const response = await api.put(`portal/inventory/${id}`, body);
  return response.data;
};

export const deleteInventoryItem = async (id) => {
  const response = await api.delete(`portal/inventory/${id}`);
  return response.data;
};

export const fetchFertilizerSales = async () => {
  const response = await api.get("portal/inventory/sales");
  return response.data;
};

export const fetchHardposDevices = async () => {
  const response = await api.get("portal/hardpos-devices");
  return response.data;
};

export const updateHardposDevice = async (id, body) => {
  const response = await api.put(`portal/hardpos-devices/${id}`, body);
  return response.data;
};

export const deleteHardposDevice = async (id) => {
  const response = await api.delete(`portal/hardpos-devices/${id}`);
  return response.data;
};

export const upsertHardposDevice = async (MID, TID, serial_number, merchant_name, cnic, mobile_no) => {
  const response = await api.post("portal/hardpos-devices", {
    MID,
    TID,
    serial_number,
    merchant_name,
    cnic,
    mobile_no,
  });
  return response.data;
};

export const createTerminal = async (body) => {
  const response = await api.post("/createTerminal", {
    TID: body.terminalId,
    MID: body.merchantId,
    PhoneNumber: `+${body.phoneNumber}`,
    attended: body.attended,
    cardholderActivated: body.cardholderActivated,
    cardPresenceCapability: body.cardPresenceCapability,
    inputCapability: body.inputCapability,
    lane: body.lane,
    location: body.location,
    onlineReasonCode: body.onlineReasonCode,
    panEntryMode: body.panEntryMode,
    pinEntryCapability: body.pinEntryCapability,
    MCC:body.MCC,
    city:body.city,
    province:body.province,
    terminalType: body.terminalType,

    // serialNumber: "",
    cards: body.cards,
    environment: body.environment,
    transactionType: body.transactionType,
  });
  return response.data;
};
export const updateTerminal = async (body) => {
  const response = await api.put(`portal/updateTerminal/${body.terminalId}`, {
    TID: body.terminalId,
    MID: body.merchantId,
    PhoneNumber: `${body.phoneNumber}`,
    attended: body.attended,
    cardholderActivated: body.cardholderActivated,
    cardPresenceCapability: body.cardPresenceCapability,
    inputCapability: body.inputCapability,
    lane: body.lane,
    location: body.location,
    onlineReasonCode: body.onlineReasonCode,
    panEntryMode: body.panEntryMode,
    pinEntryCapability: body.pinEntryCapability,
    MCC:body.MCC,
    city:body.city,
    province:body.province,
     terminalType: body.terminalType,
    // serialNumber: "",
    cards: body.cards,
    environment: body.environment,
    transactionType: body.transactionType,
  });
  return response.data;
};
export const deleteTerminalByID = async (terminalId) => {
  const response = await api.delete(`portal/deleteTerminal/${terminalId}`);
  return response.data;
};
// Onboard Merchant
export const onboardMerchant = async (merchantData) => {
  const response = await api.post("/merchant-onboard", merchantData);
  return response.data;
};
export const updateMerchant = async (data) => {
  try {
    const response = await api.put(`portal/updateMerchant/${data.MID}`, data);
    return response.data;
  } catch (err) {
    console.error("Update Merchant API Error:", err);
    throw err;
  }
};
export const deleteMerchantByID = async (MID) => {
  const response = await api.delete(`portal/deleteMerchant/${MID}`);
  return response.data;
};

// Update NAC Type
export const updateNacType = async (nacType) => {
  try {
    const response = await api.post("/portal/update-nac", { nacType });
    return response.data;
  } catch (err) {
    console.error("Failed to update NAC type:", err);
    throw err;
  }
};

// Update Message 210
export const updateMessage210 = async (message210) => {
  try {
    const response = await api.post("/portal/update-message210", {
      message210,
    });
    return response.data;
  } catch (err) {
    console.error("Failed to update Message 210:", err);
    throw err;
  }
};

export default api;
